
import {defineComponent, onBeforeMount} from "vue";
import {disableBodyOverflow} from "../../mixins";

export default defineComponent({
  name: "OnboardingBox",

  props: {
    steps: {
      type: Number,
      required: true
    },

    currentStep: {
      type: Number,
      required: true
    }
  },
  setup(props, { emit }) {
    onBeforeMount(() => disableBodyOverflow());
    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape") {
        emit("close");
      }
    });
  }

});
